import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const MonthlyKpiBarChart = () => {
  const labels = useMemo(
    () => [
      "Sep-23",
      "Oct-23",
      "Nov-23",
      "Dec-23",
      "Jan-24",
      "Feb-24",
      "Mar-24",
      "Apr-24",
      "May-24",
      "Jun-24",
      "Jul-24",
      "Aug-24"
    ],
    []
  );
  const data = useMemo(
    () => ({
      labels: labels,
      datasets: [
        {
          label: "New",
          data: [4.0, 5.0, 3.0, 2.0, 1.0, 3.0, 5.0, "", 3.0],
          backgroundColor: ["#dbf2f2"],
          borderColor: ["#6fd9d9"],
          borderWidth: 1
        },
        {
          label: "Returning",
          data: [2.0, 3.0, 2.0, 4.0, 1.0, 1.0, 4.5, 3.0, 3.0, 1.0],
          backgroundColor: ["#ebe0ff"],
          borderColor: ["#b38cff"],
          borderWidth: 1
        }
      ]
    }),
    [labels]
  );

  const options = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          display: true
        },
        tooltip: {
          enabled: true
        }
      },
      scales: {
        y: {
          beginAtZero: true
        }
      }
    }),
    []
  );

  return (
    <div className="graphSec">
      <Bar data={data} options={options} />
    </div>
  );
};

export default MonthlyKpiBarChart;
